console.log('Dimensions module loaded');

function initDimensions(container) {
  const dimensions = JSON.parse(
    container.querySelector('[data-product-small-dims-json]').textContent
  );


  const items = [...container.querySelectorAll('[data-dimension]')].map(
    item => ({
      item,
      key: item.dataset.dimension,
      figure: item.querySelector('.figure')
    })
  );

  function update(variantId) {
    const values = dimensions[variantId] || {};

    items.forEach(({ item, key, figure }) => {
      const value = values[key];
      const visible = value != null && String(value).trim() !== '';

      figure.textContent = visible ? value : '';
      item.classList.toggle('hidden', !visible);
      item.classList.toggle('is-visible', visible);
    });
  }

  update(container.dataset.variantId);

  if (typeof FoxTheme === 'undefined' || !FoxTheme.pubsub) return;

  FoxTheme.pubsub.subscribe('variant-change', ({ data }) => {
    const variantId = data?.variant?.id;

    if (variantId && Object.hasOwn(dimensions, variantId)) {
      update(variantId);
    }
  });
}

function init() {
  document.querySelectorAll('[data-product-small-dims]').forEach(initDimensions);
}

if (document.readyState === 'complete') {
  init();
} else {
  window.addEventListener('load', init, { once: true });
}